
export const fleetData = [
  {
    id: "erj-190",
    model: "ERJ-190",
    fullModel: "EMBRAER 190",
    category: "Corto Alcance",
    fleetSize: "47 Aviones",
    maxCapacity: "900KG",
    autonomy: "4,537 km",
    dimensions: {
      long: "120 cm",
      width: "101 cm",
      high: "70 cm",
      weight: "70-80 kg"
    },
    image: null // Placeholder
  },
  {
    id: "b737-700",
    model: "B737-700",
    fullModel: "BOEING 737-700",
    category: "Mediano Alcance",
    fleetSize: "11 Aviones",
    maxCapacity: "1,200 kg",
    autonomy: "6,750 km",
    dimensions: {
      long: "109 cm",
      width: "121 cm",
      high: "78 cm",
      weight: "180 kg"
    },
    image: null // Placeholder
  },
  {
    id: "b737-800",
    model: "B737F-800",
    fullModel: "BOEING 737-800",
    category: "Mediano Alcance",
    fleetSize: "36 Aviones",
    maxCapacity: "1,500 kg",
    autonomy: "5,765 km",
    dimensions: {
      long: "124 cm",
      width: "121 cm",
      high: "81 cm",
      weight: "180 kg"
    },
    image: null // Placeholder
  },
  {
    id: "b787-8",
    model: "B787-8",
    fullModel: "BOEING 787-8",
    category: "Largo Alcance",
    fleetSize: "9 Aviones",
    maxCapacity: "20,000 kg",
    autonomy: "14,200 km",
    dimensions: {
      long: "403 cm",
      width: "214 cm",
      high: "160 cm",
      weight: "70-80 kg"
    },
    image: null // Placeholder
  },
  {
    id: "b787-9",
    model: "B787-9",
    fullModel: "BOEING 787-9",
    category: "Largo Alcance",
    fleetSize: "10 Aviones",
    maxCapacity: "23,000 kg",
    autonomy: "14,800 km",
    dimensions: {
      long: "403 cm",
      width: "214 cm",
      high: "160 cm",
      weight: "180 kg"
    },
    image: null // Placeholder
  }
];
